import { render, staticRenderFns } from "./AccettazioneSsnListaPage.vue?vue&type=template&id=f1624472&scoped=true"
import script from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnListaPage.vue?vue&type=style&index=0&id=f1624472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1624472",
  null
  
)

export default component.exports